export default {"src":"/_next/static/media/lune-icon-route.a6c9955d.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};